
import { TextInput } from "@mantine/core";
import { Controller, useFormContext } from "react-hook-form";

const RHFTextInput = ({
  name,
  rules,
  defaultValue = "",

  // Extra Features
  capitalizeFirst = false,
  trimOnBlur = false,

  onValueChange,

  ...props
}) => {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      defaultValue={defaultValue}
      render={({ field, fieldState: { error } }) => {
        const handleChange = (event) => {
          let value = event.currentTarget.value;

          if (capitalizeFirst && value.length > 0) {
            value =
              value.charAt(0).toUpperCase() +
              value.slice(1);
          }

          field.onChange(value);

          if (onValueChange) {
            onValueChange(value);
          }
        };

        const handleBlur = (event) => {
          let value = event.currentTarget.value;

          if (trimOnBlur) {
            value = value.trim();
            field.onChange(value);
          }

          field.onBlur();

          if (props.onBlur) {
            props.onBlur(event);
          }
        };

        return (
          <TextInput
            {...props}
            {...field}
            value={field.value ?? ""}
            error={error?.message}
            onChange={handleChange}
            onBlur={handleBlur}
            styles={{
              label: {
              fontSize: "16px",lineHeight: "24px",fontWeight: 400,color: "#222222",marginBottom:'8px'
            }}}
          />
        );
      }}
    />
  );
};

export default RHFTextInput;